const SupportWidget = () => null;

export default SupportWidget;
